export const paymentPolicyMigrations = [
  {
    id: '039_request_sender_session_fee',
    sql: `
      ALTER TABLE meeting_payment_obligations
        DROP CONSTRAINT IF EXISTS meeting_payment_obligations_status_check;
      ALTER TABLE meeting_payment_obligations
        ADD CONSTRAINT meeting_payment_obligations_status_check
        CHECK (status IN ('pending', 'submitted', 'paid', 'rejected', 'waived'));

      UPDATE meeting_payment_obligations payment SET status='waived',updated_at=NOW()
      FROM meeting_proposals meeting
      JOIN journeys journey ON journey.id=meeting.journey_id
      JOIN engagement_requests relationship ON relationship.id=journey.request_id
      WHERE payment.meeting_id=meeting.id
        AND payment.beneficiary_user_id<>relationship.sender_user_id
        AND payment.status<>'paid';
    `,
  },
  {
    id: '040_shared_session_fee_checkout',
    sql: `
      INSERT INTO meeting_payment_obligations (meeting_id, beneficiary_user_id)
      SELECT meeting.id, participant.user_id
      FROM meeting_proposals meeting
      JOIN journeys journey ON journey.id=meeting.journey_id
      CROSS JOIN LATERAL (VALUES (journey.first_user_id),(journey.second_user_id)) participant(user_id)
      WHERE meeting.status IN ('confirmed','completed')
      ON CONFLICT (meeting_id, beneficiary_user_id) DO NOTHING;

      UPDATE meeting_payment_obligations payment SET status='pending',updated_at=NOW()
      WHERE payment.status='waived'
        AND NOT EXISTS (
          SELECT 1 FROM meeting_payment_obligations completed
          WHERE completed.meeting_id=payment.meeting_id AND completed.status='paid'
        );
    `,
  },
] as const;
